import ApiService from '@/utils/ApiService'
export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: [],
    totalItems: 0
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view,
    totalItems: (state) => state.totalItems
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    },
    setTotalItems (state, totalItems) {
      state.totalItems = totalItems
    }
  },
  actions: {
    async getItems ({ commit }, url = 'e_x_s_b_refunds') {
      commit('toggleLoading')
      const response = await new ApiService(url).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('setTotalItems', await response.totalItems)
      commit('toggleLoading')
    }
  }
}
